
import { SWRConfiguration, SWRResponse } from "swr";

import { GetSourceDataReport, IReturn, QuerySourceDataEvents, GetSourceDataReportUsersResponse, SourceDataEvent, SourceDataEventContext, SourceDataFormContext, SourceDataPoint, GetSourceDataReportUsers, SourceDataReportUser } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<GetSourceDataReportUsersResponse, GetSourceDataReportUsersResponse>) => response?.data?.users;
const getError = (response?: SWRResponse<GetSourceDataReportUsersResponse, GetSourceDataReportUsersResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetSourceDataReportUsersResponse, GetSourceDataReportUsersResponse>) => ({
    usernameMap: response?.data?.users?.reduce<Record<string,SourceDataReportUser>>((a, b) => {
        a[b.username!] = b;

        return a;
    }, {})
});

export const useSourceDataReportUsers = (query?: Partial<GetSourceDataReportUsers>, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetSourceDataReportUsers(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useSourceDataReportUsers;